import { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SectionTitle, MoneyStat } from "@/components/Bits";
import { InvoiceForm, InvoiceTable } from "@/pages/Invoices";

export default function ProjectInvoices({ projectId }) {
  const { isStaff } = useAuth();
  const [rows, setRows] = useState([]);

  const load = () =>
    api.get("/invoices", { params: { project_id: projectId } }).then((r) => setRows(r.data)).catch(() => setRows([]));

  useEffect(() => { load(); }, [projectId]); // eslint-disable-line react-hooks/exhaustive-deps

  const live = rows.filter((r) => !["Draft", "Void", "Refunded"].includes(r.status));
  const invoiced = live.reduce((a, r) => a + (r.total || 0), 0);
  const paid = live.reduce((a, r) => a + (r.amount_paid || 0), 0);
  const outstanding = live.reduce((a, r) => a + (r.balance || 0), 0);

  return (
    <div className="space-y-10" data-testid="tab-invoices">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <SectionTitle>Invoices &amp; Payments</SectionTitle>
        {isStaff && <InvoiceForm projectId={projectId} onCreated={load} />}
      </div>
      <div className="card-surface grid gap-8 p-7 sm:grid-cols-3">
        <MoneyStat testId="project-invoiced" label="Invoiced" value={invoiced} />
        <MoneyStat testId="project-received" label="Received" value={paid} tone="text-lime-dark" />
        <MoneyStat testId="project-outstanding" label="Outstanding" value={outstanding}
          sub={`${live.filter((r) => r.balance > 0).length} open invoice(s)`} />
      </div>
      <InvoiceTable rows={rows} showProject={false} />
      <p className="text-xs text-fog">Totals here reflect verified Square payments and are kept separate from the project budget — {money(invoiced)} invoiced to date.</p>
    </div>
  );
}
